import * as _ from 'lodash-es';

// width can't be too small otherwise legends can be easily cutoff.
// https://github.com/mermaid-js/mermaid/issues/2073
const MIN_WIDTH = 880;

const loadMermaid = _.once(async () => {
  return (await import('mermaid')).default;
});

const initializeMermaid = async (darkMode: boolean, width?: number) => {
  const mermaid = await loadMermaid();

  const useWidth = Math.max(width || 0, MIN_WIDTH);

  mermaid.initialize({
    startOnLoad: false,
    fontFamily: 'inherit',
    theme: darkMode ? 'dark' : 'default',
    gantt: { useWidth },
  });
  return mermaid;
};

const getMermaidRenderToString =
  (darkMode: boolean) => async (code: string, width?: number) => {
    const mermaid = await initializeMermaid(darkMode, width);
    const tempContainer = document.createElement('div');
    Object.assign(tempContainer.style, {
      visibility: 'hidden',
      pointerEvents: 'none',
      position: 'absolute',
    });
    document.body.appendChild(tempContainer);
    try {
      const { svg } = await mermaid.render(
        _.uniqueId('mermaid'),
        code,
        tempContainer,
      );
      return svg;
    } finally {
      tempContainer.remove();
    }
  };

export default getMermaidRenderToString;
